import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Card, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { formatPrice } from "@/utils/formatPrice";
import moment from "moment";

const columns = [
  {
    flex: 1,
    field: "car_id",
    headerName: "Car Id",
    valueGetter: (params) => params.row.car_id,
  },
  {
    flex: 1,
    field: "state",
    headerName: "State",
    valueGetter: (params) => params.row.state,
  },

  {
    flex: 1,
    field: "price",
    headerName: "Price",
    valueGetter: (params) => formatPrice(params.row.price),
  },

  {
    flex: 1,
    field: "fromDate",
    headerName: "From",
    minWidth: 150,
    valueGetter: (params) => moment(params.row.fromDate).format("MMMM Do YYYY"),
  },

  {
    flex: 1,
    field: "toDate",
    headerName: "To",
    minWidth: 150,
    valueGetter: (params) => moment(params.row.toDate).format("MMMM Do YYYY"),
  },
  {
    flex: 1,
    field: "view",
    headerName: "View",
    sortable: false,
    minWidth: 90,
    headerAlign: "center",
    align: "center",
    // flex: 1,
    disableClickEventBubbling: true,
    renderCell: () => {
      return <Button variant="outlined">View</Button>;
    },
  },
];

const CarListing = ({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  handleSelectCar,
}) => {
  function handleCellClick(params) {
    console.log(params);

    if (params.field === "view") {
      handleSelectCar(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          // sx={{ width: "100%", overflowX: "scroll" }}
          rows={data?.carList}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
        />
      </Box>
    </Card>
  );
};

export default CarListing;

CarListing.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.any,
  data: PropTypes.shape({
    carList: PropTypes.arrayOf(
      PropTypes.shape({
        car_id: PropTypes.string,
        state: PropTypes.string,
        price: PropTypes.number,
      })
    ),
  }),
  rowCountState: PropTypes.number,
  paginationModel: PropTypes.shape({
    pageSize: PropTypes.number,
    page: PropTypes.number,
  }),
  setPaginationModel: PropTypes.func,
};
